export const errorMessages = {
  400: "Validation has failed.",
  401: "Your session has expired and the application has failed to get a new session silently. Please make sure popups are allowed for the app to renew sessions.",
  403: "You are not authorized to access this resource. Please try logging out and logging back again. If the issue continues, contact your Tenant Admin for assistance.",
  404: "The resource you are looking for or a part of it cannot be found in the system.",
  503: "The system is temporarily down. Please try again in a short time.",
  500: "We're currently experiencing technical difficulties. If this problem persists, please contact our support team.",
};

export const getErrorMessage = (statusCode) => {
  return errorMessages[statusCode] || "An error occurred.";
};
